import Vue from 'vue'

import '@/global/index'

// 引入该页面个性化UI组件
import {
  Card, Link, Tabs, TabPane, Breadcrumb, BreadcrumbItem, Divider, Checkbox, InfiniteScroll
} from 'element-ui'

Vue.use(Card)
Vue.use(Link)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Divider)
Vue.use(Checkbox)
Vue.use(InfiniteScroll)

import store from '@/store/global-store'
import App from './App'

new Vue({
  store,
  render: h => h(App),
  created: function () {
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/seeker/person/m_collection/m_collection.js